module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=SS - South Sudan.236053e3.svg";